import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select from 'react-select';

import { OfficeAction, PurchaseAction, SaleAction } from '../../store/actions';

class Form extends PureComponent {
  static propTypes = {
    authHasOffice: PropTypes.bool,
    authOfficeId: PropTypes.number,
    authOfficeName: PropTypes.string,
    createSale: PropTypes.func,
    editSale: PropTypes.func,
    getOffices: PropTypes.func,
    getPurchases: PropTypes.func,
    getSale: PropTypes.func,
    offices: PropTypes.arrayOf(PropTypes.object),
    purchases: PropTypes.arrayOf(PropTypes.object),
    sale: PropTypes.object,
    saleId: PropTypes.number,
  };

  constructor(props) {
    super(props);
    this.state = this.getInitialState(props.sale);
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    if (this.props.saleId) {
      this.props.getSale(this.props.saleId);
    }
    this.props.getPurchases({ office_id: this.state.office_id, sale: true });
  }

  componentDidUpdate(props, _state, _snapshot) {
    if (JSON.stringify(props.sale) !== JSON.stringify(this.props.sale)) {
      this.setState({ ...this.getInitialState(this.props.sale) });
    }
  }

  getInitialState(sale) {
    const officeId = [this.props.authOfficeId, sale?.office_id, '']?.find?.(
      i => i,
    );
    const officeSelected = [
      this.props.authOfficeId && {
        label: this.props.authOfficeName,
        value: this.props.authOfficeId,
      },
      sale?.office?.id && {
        label: sale?.office?.name,
        value: sale?.office?.id,
      },
      '',
    ]?.find?.(i => i);
    return {
      advance: sale?.advance || '',
      customer: sale?.customer || {
        address: sale?.customer?.address || '',
        father_name: sale?.customer?.father_name || '',
        gender: sale?.customer?.gender || '',
        mobile_number: sale?.customer?.mobile_number || '',
        name: sale?.customer?.name || '',
        national_id: sale?.customer?.national_id || '',
      },
      discount: sale?.discount || '',
      installments: sale?.installments || '',
      interest_rate: sale?.interest_rate || '',
      office_id: officeId || '',
      office_selected: officeSelected || '',
      price: sale?.price || '',
      purchase_id: sale?.purchase_id || '',
      purchase_selected: sale?.purchase?.id
        ? {
            label: `${sale?.purchase?.vehicle?.model} - ${sale?.purchase?.chassis_number} - ${sale?.purchase?.engine_number}`,
            value: sale?.purchase?.id,
          }
        : '',
      sold_at: sale?.sold_at || '',
      total: sale?.total || '',
      use_installment: !!(sale?.installments || ''),
    };
  }

  onChange(event) {
    const { target: { name, value } = {} } = event;
    this.setState({ [name]: value });
  }

  onClear(_) {
    this.setState(this.getInitialState());
  }

  onSelect(option, action) {
    const { _name, name } = action;
    const { value } = option;
    this.setState({ [name]: option, [_name]: value });
  }

  onSubmit(event) {
    event.preventDefault();
    if (!confirm('Are you sure?')) {
      return;
    }
    if (this.props.saleId) {
      this.props.editSale(this.props.saleId, this.state);
    } else {
      this.props.createSale(this.state);
    }
  }

  render() {
    return (
      <div className="row">
        <div className="col">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">
                {this.props.saleId ? 'Edit' : 'Create'} Sale
              </h3>
            </div>
            <form onSubmit={this.onSubmit.bind(this)}>
              <div className="card-body">
                {!this.props.authHasOffice && (
                  <div className="form-row">
                    <div className="form-group col">
                      <label htmlFor="office_id">Office</label>
                      <Select
                        id="office_id"
                        isDisabled={this.props.authHasOffice}
                        name="office_selected"
                        onChange={(option, action) =>
                          this.onSelect(option, {
                            ...action,
                            _name: 'office_id',
                          })
                        }
                        onInputChange={value => {
                          value && this.props.getOffices({ query: value });
                        }}
                        options={this.props.offices}
                        placeholder="Select Office"
                        value={this.state.office_selected}
                      />
                    </div>
                  </div>
                )}
                <CustomerInputs
                  {...this.state.customer}
                  onChange={value =>
                    this.onChange({ target: { name: 'customer', value } })
                  }
                />
                <div className="form-row">
                  <div className="form-group col">
                    <label htmlFor="sold_at">Sell At</label>
                    <input
                      className="form-control"
                      id="sold_at"
                      name="sold_at"
                      onChange={this.onChange}
                      placeholder="Sell At"
                      type="date"
                      value={this.state.sold_at}
                    />
                  </div>
                  <div className="form-group col">
                    <label htmlFor="purchase_id">Purchased Vehicle</label>
                    <Select
                      id="purchase_id"
                      name="purchase_selected"
                      onChange={(option, action) =>
                        this.onSelect(option, {
                          ...action,
                          _name: 'purchase_id',
                        })
                      }
                      onInputChange={value => {
                        value &&
                          this.props.getPurchases({
                            office_id: this.state.office_id,
                            query: value,
                            sale: true,
                          });
                      }}
                      options={this.props.purchases}
                      placeholder="Select Vehicle"
                      value={this.state.purchase_selected}
                    />
                  </div>
                  <div className="form-group col">
                    <label htmlFor="price">Price</label>
                    <input
                      className="form-control"
                      id="price"
                      name="price"
                      onChange={event => {
                        const { target: { name, value } = {} } = event;
                        this.setState(
                          ({ discount }) => ({
                            advance: value - discount,
                            total: value - discount,
                          }),
                          () => this.onChange({ target: { name, value } }),
                        );
                      }}
                      placeholder="Price"
                      type="number"
                      value={this.state.price}
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group col">
                    <label htmlFor="discount">Discount</label>
                    <input
                      className="form-control"
                      id="discount"
                      name="discount"
                      onChange={event => {
                        const { target: { name, value } = {} } = event;
                        this.setState(
                          ({ price }) => ({
                            advance: price - value,
                            total: price - value,
                          }),
                          () => this.onChange({ target: { name, value } }),
                        );
                      }}
                      placeholder="Discount"
                      type="number"
                      value={this.state.discount || ''}
                    />
                  </div>
                  <div className="form-group col">
                    <label htmlFor="total">Total</label>
                    <input
                      className="form-control"
                      id="total"
                      name="total"
                      onChange={this.onChange}
                      placeholder="Total"
                      readOnly
                      type="number"
                      value={this.state.total}
                    />
                  </div>
                  <div className="form-group col">
                    <label htmlFor="advance">Advance</label>
                    <input
                      className="form-control"
                      id="advance"
                      name="advance"
                      onChange={this.onChange}
                      placeholder="Advance"
                      type="number"
                      value={this.state.advance}
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group col">
                    <div className="custom-control custom-checkbox">
                      <input
                        checked={this.state.use_installment}
                        className="custom-control-input"
                        id="use_installment"
                        name="use_installment"
                        onChange={event => {
                          const {
                            target: { checked: value, name } = {},
                          } = event;
                          this.setState(
                            value
                              ? { installments: 20, interest_rate: 0.8 }
                              : { installments: '', interest_rate: '' },
                            () => this.onChange({ target: { name, value } }),
                          );
                        }}
                        type="checkbox"
                      />
                      <label
                        htmlFor="use_installment"
                        className="custom-control-label"
                      >
                        Use Installment
                      </label>
                    </div>
                  </div>
                </div>
                {this.state.use_installment && (
                  <div className="form-row">
                    <div className="form-group col">
                      <label htmlFor="installments">
                        Number of Installments
                      </label>
                      <input
                        className="form-control"
                        id="installments"
                        name="installments"
                        onChange={this.onChange}
                        placeholder="Number of Installments"
                        type="number"
                        value={this.state.installments || ''}
                      />
                    </div>
                    <div className="form-group col">
                      <label htmlFor="interest_rate">Interest Rate</label>
                      <input
                        className="form-control"
                        id="interest_rate"
                        name="interest_rate"
                        onChange={this.onChange}
                        placeholder="Interest Rate"
                        step="0.01"
                        type="number"
                        value={this.state.interest_rate || ''}
                      />
                    </div>
                  </div>
                )}
              </div>
              <div className="card-footer">
                <button className="btn btn-primary" type="submit">
                  Save
                </button>
                <button
                  className="btn btn-warning float-right"
                  onClick={this.onClear.bind(this)}
                  type="reset"
                >
                  Clear
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  authHasOffice: !!state?.auth?.office,
  authOfficeId: state?.auth?.office?.id,
  authOfficeName: state?.auth?.office?.name,
  offices: state?.office?.list?.data?.map?.(row => ({
    label: row.name,
    value: row.id,
  })),
  purchases: state?.purchase?.list?.data?.map?.(row => ({
    label: `${row?.vehicle?.model} - ${row?.chassis_number} - ${row?.engine_number}`,
    value: row.id,
  })),
  sale: state?.sale?.detail,
  saleId: Number(props?.match?.params?.id),
});

const mapDispatchToProps = dispatch => ({
  createSale: data => dispatch(SaleAction.createSale(data)),
  editSale: (id, data) => dispatch(SaleAction.editSale(id, data)),
  getOffices: params => dispatch(OfficeAction.getOffices(params)),
  getPurchases: params => dispatch(PurchaseAction.getPurchases(params)),
  getSale: id => dispatch(SaleAction.getSale(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Form);

class CustomerInputs extends PureComponent {
  static propTypes = {
    address: PropTypes.string,
    father_name: PropTypes.string,
    gender: PropTypes.string,
    mobile_number: PropTypes.string,
    name: PropTypes.string,
    national_id: PropTypes.string,
    onChange: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  onChange(event) {
    const { target: { name, value } = {} } = event;
    const { onChange, ...data } = this.props;
    onChange({ ...data, [name]: value });
  }

  render() {
    return (
      <>
        <div className="form-row">
          <div className="form-group col">
            <label htmlFor="name">Name</label>
            <input
              className="form-control"
              id="name"
              name="name"
              onChange={this.onChange}
              placeholder="Name"
              type="text"
              value={this.props.name}
            />
          </div>
          <div className="form-group col">
            <label htmlFor="gender">Gender</label>
            <Select
              id="gender"
              name="gender"
              onChange={(option, action) => this.onChange({
                target: { name: action?.name, value: option?.value },
              })}
              options={[{
                label: 'Male',
                value: 'male',
              }, {
                label: 'Female',
                value: 'female',
              }]}
              placeholder="Select Gender"
              value={this.props.gender ? {
                label: this.props.gender?.charAt?.(0)?.toUpperCase?.() + this.props.gender?.slice?.(1),
                value: this.props.gender || '',
              } : {
                label: 'Male',
                value: 'male',
              }}
            />
          </div>
          <div className="form-group col">
            <label htmlFor="father_name">Father Name</label>
            <input
              className="form-control"
              id="father_name"
              name="father_name"
              onChange={this.onChange}
              placeholder="Father Name"
              type="text"
              value={this.props.father_name}
            />
          </div>
        </div>
        <div className="form-row">
          <div className="form-group col">
            <label htmlFor="mobile_number">Mobile Number</label>
            <input
              className="form-control"
              id="mobile_number"
              name="mobile_number"
              onChange={this.onChange}
              placeholder="Mobile Number"
              type="text"
              value={this.props.mobile_number}
            />
          </div>
          <div className="form-group col">
            <label htmlFor="national_id">National ID</label>
            <input
              className="form-control"
              id="national_id"
              name="national_id"
              onChange={this.onChange}
              placeholder="National ID"
              type="text"
              value={this.props.national_id}
            />
          </div>
          <div className="form-group col">
            <label htmlFor="address">Address</label>
            <textarea
              className="form-control"
              id="address"
              name="address"
              onChange={this.onChange}
              placeholder="Address"
              value={this.props.address}
            />
          </div>
        </div>
      </>
    );
  }
}
